import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);

const NewsSlider = (target) => {

  const method = {
    init: () => {
      const swiper = new Swiper(target, {
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }
  method.init();
}

export default NewsSlider;